import { render, staticRenderFns } from "./UserPhoto.vue?vue&type=template&id=4ddb537d&scoped=true&v-if=icon"
import script from "./UserPhoto.vue?vue&type=script&lang=ts"
export * from "./UserPhoto.vue?vue&type=script&lang=ts"
import style0 from "./UserPhoto.vue?vue&type=style&index=0&id=4ddb537d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddb537d",
  null
  
)

export default component.exports